<div class="container-box">
  <app-table-header tableTitle="Noleggio pratiche" (btnUpdateClick)="loadRentalPractices()">
    <app-button-new-rental-practice action-button></app-button-new-rental-practice>
  </app-table-header>
  <div class="table-container">
    <ng2-smart-table
      id="rentalPracticesTable"
      class="table-content"
      [settings]="settings"
      [source]="source"
    ></ng2-smart-table>
  </div>
</div>
